import { render } from "./pheader.vue?vue&type=template&id=337a6b23&scoped=true"
import script from "./pheader.vue?vue&type=script&lang=js"
export * from "./pheader.vue?vue&type=script&lang=js"

import "./pheader.vue?vue&type=style&index=0&id=337a6b23&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-337a6b23"]])

export default __exports__